import { render } from "./BasicRightContent.vue?vue&type=template&id=2f613acb"
import script from "./BasicRightContent.vue?vue&type=script&lang=js"
export * from "./BasicRightContent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/guohongcheng/Documents/jeff/jeff_spn_mini/user_interface/web/vue/tianping/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__